import React, { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import DefaultLayout from "src/layout/DefaultLayout";

import { CContainer, CSpinner } from "@coreui/react-pro";
import AuthService from "src/components/modules/auth/redux/AuthService";
import EvaluatorReport from "src/views/EvaluatorReport/EvaluatorReport";

const PrivateRoutes = () => {
  const Dashboard = React.lazy(() => import("./../views/dashboard/Dashboard"));
  const NewForm = React.lazy(() => import("./../views/application/NewForm"));
  const ApplicationList = React.lazy(() =>
    import("./../views/application/list")
  );
  const ApplicationListDetail = React.lazy(() =>
    import("./../views/application/ListDetail")
  );
  const SelfReport = React.lazy(() =>
    import("./../views/SelfReport/SelfReport")
  );
  const SelfReportDetail = React.lazy(() =>
    import("./../views/SelfReport/SelfReportDetail")
  );
  const MonthResponse = React.lazy(() =>
    import("./../views/Response/MonthResponse")
  );
  const MonthResponseDetail = React.lazy(() =>
    import("./../views/Response/MonthResponseDetail")
  );
  const Evaluation = React.lazy(() =>
    import("./../views/Evaluation/Evaluation")
  );
  const EvaluationDetail = React.lazy(() =>
    import("./../views/Evaluation/EvaluationDetail")
  );
  const SelfReportPreview = React.lazy(() =>
    import("./../views/ReportPreview/SelfReportPreview")
  );
  const SelfReportPreviewDetail = React.lazy(() =>
    import("./../views/ReportPreview/SelfReportPreviewDetail")
  );
  const ApplicationLoopScreen = React.lazy(() =>
    import("./../views/application/ApplicationLoopScreen")
  );
  const ApplicationLoopScreenDetail = React.lazy(() =>
    import("./../views/application/ApplicationLoopScreenDetail")
  );
  const DraftReport = React.lazy(() =>
    import("./../views/DraftReport/DraftReport")
  );
  const DraftReportDetail = React.lazy(() =>
    import("./../views/DraftReport/DraftReportDetail")
  );
  const ConsistencyFinalReport = React.lazy(() =>
    import("./../views/ConsistencyFinalReport/ConsistencyFinalReport")
  );
  const ConsistencyFinalReportDetail = React.lazy(() =>
    import("./../views/ConsistencyFinalReport/ConsistencyFinalReportDetail")
  );
  const FinalReport = React.lazy(() =>
    import("./../views/FinalReport/FinalReport")
  );
  const FinalReportDetail = React.lazy(() =>
    import("./../views/FinalReport/FinalReportDetail")
  );
  const Consistency = React.lazy(() =>
    import("./../views/ConsistentView/Consistency")
  );
  const ConsistencyDetail = React.lazy(() =>
    import("./../views/ConsistentView/ConsistencyDetail")
  );
  const Editor = React.lazy(() => import("./../views/Editor/Editor"));
  const EditorDetail = React.lazy(() =>
    import("./../views/Editor/EditorDetail")
  );
  const SpellingControl = React.lazy(() =>
    import("./../views/SpellingControl/SpellingControl")
  );
  const SpellingControlDetail = React.lazy(() =>
    import("./../views/SpellingControl/SpellingControlDetail")
  );
  const AppealTemplate = React.lazy(() =>
    import("./../views/Templates/AppealTemplate")
  );
  const IntentionLetter = React.lazy(() =>
    import("./../views/Templates/IntentionLetter")
  );
  const PersonalAppealTemplate = React.lazy(() =>
    import("./../views/Templates/PersonalAppealTemplate")
  );
  const EthicsDeal = React.lazy(() =>
    import("./../views/Templates/EthicsDeal")
  );
  const SekilselInceleme = React.lazy(() =>
    import("./../views/SekilselInceleme/SekilselInceleme")
  );
  const SekilselIncelemeDetay = React.lazy(() =>
    import("./../views/SekilselInceleme/SekilselIncelemeDetay")
  );
  const EthicsTemplate = React.lazy(() =>
    import("./../views/Templates/EthicsTemplate")
  );
  const TeamLeaderAppealTemplate = React.lazy(() =>
    import("./../views/Templates/TeamLeaderAppealTemplate")
  );
  const TeamAppealTemplateForFinalReport = React.lazy(() =>
    import("./../views/Templates/TeamAppealTemplateForFinalReport")
  );
  const Try = React.lazy(() => import("./../views/application/try"));

  const role = AuthService.GetCurrentUser()?.userData.roles;

  let usr = {
    role: role,
  };


  const admin = role.includes("admin");
  const kurum = role.includes("Kurum");
  const teamLeader = role.includes("TB");
  const editor = role.includes("Editor");
  const consistency = role.includes("TKK");
  const spelling = role.includes("YKK");
  const evaluator = role.includes("Degerlendirici");
  const student = role.includes("Öğrenci");
  const watcher = role.includes("Gözlemci");

  if (admin) {
    usr.role = "admin";
  } else if (teamLeader) {
    usr.role = "teamLeader";
  } else if (editor) {
    usr.role = "editor";
  } else if (consistency) {
    usr.role = "consistency";
  } else if (spelling) {
    usr.role = "spelling";
  } else if (evaluator) {
    usr.role = "evaluator";
  } else if (kurum) {
    usr.role = "organisation";
  } else if (student) {
    usr.role = "student";
  } else if (watcher) {
    usr.role = "watcher";
  }


  return (
    <Suspense fallback={<CSpinner color="primary" />}>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path="auth/*" element={<Navigate to="/dashboard" />} />
          <Route path="sign-up/*" element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          {usr?.role == "organisation" ? (
            <>
              <Route path="application-list" element={<ApplicationList />} />
              <Route path="new-app-form" element={<NewForm />} />
              <Route
                path="application-list-detail"
                element={<ApplicationListDetail />}
              />
              <Route path="self-report" element={<SelfReport />} />
              <Route path="self-report-detail" element={<SelfReportDetail />} />
              <Route
                path="application-loop"
                element={<ApplicationLoopScreen />}
              />
              <Route
                path="application-loop-detail"
                element={<ApplicationLoopScreenDetail />}
              />
              <Route path="month-response" element={<MonthResponse />} />
              <Route
                path="month-response-detail"
                element={<MonthResponseDetail />}
              />
              <Route path="appeal-template" element={<AppealTemplate />} />
              <Route path="intention-letter" element={<IntentionLetter />} />
              <Route path="ethics-deal" element={<EthicsDeal />} />
            </>
          ) : (
            <></>
          )}
          {
            /* usr?.role == "teamLeader" || usr?.role == "admin" */ role?.includes(
              "TB"
            ) ? (
              <>
                <Route path="appeal-template" element={<AppealTemplate />} />
                <Route path="ethics-template" element={<EthicsTemplate />} />
                <Route path="team-leader-appeal-template" element={<TeamLeaderAppealTemplate />} />
                <Route path="team-appeal-template-for-final-report" element={<TeamAppealTemplateForFinalReport />} />
                <Route
                  path="self-report-preview"
                  element={<SelfReportPreview />}
                />
                <Route path="formal-review" element={<SekilselInceleme />} />
                <Route
                  path="formal-review-detail"
                  element={<SekilselIncelemeDetay />}
                />
                <Route
                  path="self-report-preview-detail"
                  element={<SelfReportPreviewDetail />}
                />
                <Route path="evaluator-report" element={<EvaluatorReport />} />
                <Route path="draft-report" element={<DraftReport />} />
                <Route
                  path="draft-report-detail"
                  element={<DraftReportDetail />}
                />
                <Route path="consistency-final-report" element={<ConsistencyFinalReport />} />
                <Route
                  path="consistency-final-report-detail"
                  element={<ConsistencyFinalReportDetail />}
                />
                <Route path="final-report" element={<FinalReport />} />
                <Route
                  path="final-report-detail"
                  element={<FinalReportDetail />}
                />
                <Route
                  path="application-loop"
                  element={<ApplicationLoopScreen />}
                />
                <Route
                  path="application-loop-detail"
                  element={<ApplicationLoopScreenDetail />}
                />
              </>
            ) : (
              <></>
            )
          }
          {usr?.role == "admin" ? (
            <>
              <Route path="final-report" element={<FinalReport />} />
              <Route
                path="final-report-detail"
                element={<FinalReportDetail />}
              />
            </>
          ) : (
            <></>
          )}
          {usr?.role == "evaluator" ||
          usr?.role == "admin" ||
          role?.includes("Degerlendirici") ? (
            <>
              <Route path="appeal-template" element={<AppealTemplate />} />
              <Route path="ethics-template" element={<EthicsTemplate />} />
              <Route path="formal-review" element={<SekilselInceleme />} />
              <Route path="evaluation" element={<Evaluation />} />
              <Route path="evaluation-detail" element={<EvaluationDetail />} />
              <Route
                path="self-report-preview"
                element={<SelfReportPreview />}
              />
              <Route path="final-report" element={<FinalReport />} />
              <Route
                path="final-report-detail"
                element={<FinalReportDetail />}
              />
              <Route
                path="self-report-preview-detail"
                element={<SelfReportPreviewDetail />}
              />
            </>
          ) : (
            <></>
          )}
          {usr?.role == "consistency" || usr?.role == "admin" ? (
            <>
              <Route path="consistency" element={<Consistency />} />
              <Route
                path="consistency-detail"
                element={<ConsistencyDetail />}
              />
            </>
          ) : (
            <></>
          )}
          {usr?.role == "editor" ? (
            <>
              <Route path="editor" element={<Editor />} />
              <Route path="editor-detail" element={<EditorDetail />} />
            </>
          ) : (
            <></>
          )}
          {role?.includes("Öğrenci") || usr?.role == "student" ? (
            <>
              <Route path="ethics-template" element={<EthicsTemplate />} />
              <Route
                path="self-report-preview"
                element={<SelfReportPreview />}
              />
              <Route
                path="self-report-preview-detail"
                element={<SelfReportPreviewDetail />}
              />
              <Route path="final-report" element={<FinalReport />} />
              <Route
                path="final-report-detail"
                element={<FinalReportDetail />}
              />
              <Route path="evaluator-report" element={<EvaluatorReport />} />
            </>
          ) : (
            <></>
          )}
          {role?.includes("Gözlemci") || usr?.role == "watcher" ? (
            <>
              <Route path="ethics-template" element={<EthicsTemplate />} />
              <Route
                path="self-report-preview"
                element={<SelfReportPreview />}
              />
              <Route
                path="self-report-preview-detail"
                element={<SelfReportPreviewDetail />}
              />
              <Route path="final-report" element={<FinalReport />} />
              <Route
                path="final-report-detail"
                element={<FinalReportDetail />}
              />
              <Route path="evaluator-report" element={<EvaluatorReport />} />
            </>
          ) : (
            <></>
          )}
          {usr?.role == "spelling" ? (
            <>
              <Route path="spelling-control" element={<SpellingControl />} />
              <Route
                path="spelling-control-detail"
                element={<SpellingControlDetail />}
              />
            </>
          ) : (
            <></>
          )}
          {usr?.role == "admin" || role?.includes("Degerlendirici") || role?.includes("Öğrenci") || role?.includes("Gözlemci") || role?.includes("TB")  ? (
            <>
              <Route path="personal-appeal-template" element={<PersonalAppealTemplate />} />
            </>
          ) : (
            <></>
          )}

          <Route path="*" element={<Navigate to="/error/404" />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export { PrivateRoutes };
